/* eslint-disable */
/* eslint-disable react/prop-types */
import { Grid, IconButton, Snackbar, TextField, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import BusinessIcon from '@material-ui/icons/Business';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import LinkIcon from '@material-ui/icons/Link';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import ServicesContext from '../../Contexts/Services/Services.context';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_REPORT_REQUESTED } from '../../State/Store/UI/UI.types';
import envGet from '../../Support/Env/Get/EnvGet.support';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import helpersValidation from '../../Support/Validation';
import AccountSwitcher from '../AccountSwitcher/AccountSwitcher.component';
import DateRangeSelector from '../DateRangeSelector/DateRangeSelector.component';
import Spinner from '../Spinner/Spinner.component';
import reportFormStyles from './ReportForm.component.styles';

const REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL = envGet({ key: `REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL` });

/**
 * ReportForm
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const ReportForm = ({ actions, classes, meta, width }) => {
  const yesterday = moment()
    .subtract(1, `days`)
    .format(`YYYY-MM-DD`);
  const services = useContext(ServicesContext);
  const [accounts, setAccounts] = useState([]);
  const [downloadError, setDownloadError] = useState();
  const [isCustom, setIsCustom] = useState();
  const [isDownloading, setIsDownloading] = useState();
  const [currentAccount, setCurrentAccount] = useState(null);
  const [payload, setPayload] = useState({
    account: ``,
    dateFrom: yesterday,
    dateTo: yesterday,
    meta,
  });

  /**
   * requestDownload
   * @returns {void}
   * @returns {React.Component} The component
   */
  const requestDownload = async () => {
    try {
      actions.uiTriggered({
        payload: {
          data: {
            name: meta,
          },
        },
        type: UI_REPORT_REQUESTED,
      });
      setIsDownloading(true);
      await services.docketService.downloadReport({ ...payload, generatedOn: moment().format(`DDMMYYYY`) });
      setIsDownloading(false);
    } catch (ex) {
      setIsDownloading(false);
      setDownloadError(true);
    }
    return;
  };

  /**
   * componentDidUpdate
   * @param {string} date value to be checked
   * @returns {boolean} boolean if date fits into range
   * @memberof OrderListComponent
   */
  const isValidRange = (date) => {
    return (
      !date ||
      moment(date).isAfter(moment().subtract(1, `days`)) ||
      moment(date).isBefore(
        moment()
          .subtract(2, `months`)
          .startOf(`month`),
      )
    );
  };

  useEffect(() => {
    (async () => {
      const retrievedAccounts = await services.userService.getUserAccounts();
      const billToAccounts = services.authService.getGroups() || [];
      // find names associated with each billToAccount
      setAccounts(
        billToAccounts.map((billToAccount) => {
          const foundAccount = retrievedAccounts.accounts.find((account) => {
            return helpers.getNumberFromBillTo(billToAccount) === account.CustomerCode.trim();
          });
          if (foundAccount) {
            return {
              accountName: foundAccount.AccountName,
              billTo: billToAccount,
            };
          }
          // no matching account name then as a backup display billTo number
          return {
            accountName: billToAccount,
            billTo: billToAccount,
          };
        }),
      );
      setPayload({ ...payload, account: helpers.getNumberFromBillTo(billToAccounts[0]) });
    })();
  }, []);

  const isSmDown = isWidthDown(`xs`, width);

  return accounts.length > 0 ? (
    <React.Fragment>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setDownloadError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            An error has occurred. Please try again later.
          </span>
        }
        open={downloadError}
      />

      <Grid alignItems="center" className={classes.marginBottom3unit} container spacing={2} wrap="nowrap">
        {!isSmDown && (
          <Grid item>
            <BusinessIcon className={classes.nakedIcon} />
          </Grid>
        )}
        <Grid item md={6} xs={isSmDown ? 12 : 8}>
          <AccountSwitcher
            accounts={accounts}
            label="Account"
            onChange={(value) => {
              // actions.filtersSelectAccount(value);
              setCurrentAccount(value);
              setPayload({
                ...payload,
                account: helpers.getNumberFromBillTo(value),
              });
            }}
            value={currentAccount}
          />
        </Grid>
      </Grid>

      <Grid alignItems="center" className={classes.marginBottom3unit} container spacing={2} wrap="nowrap">
        {!isSmDown && (
          <Grid item>
            <CalendarTodayIcon className={classes.nakedIcon} />
          </Grid>
        )}
        <Grid item md={3} sm={4} xs={12}>
          <DateRangeSelector
            isCustom={isCustom}
            label="Date range"
            onChange={(value) => {
              setIsCustom(false);
              setPayload({
                ...payload,
                dateFrom: value.dateFrom,
                dateTo: value.dateTo,
              });
            }}
          />
        </Grid>
      </Grid>

      <Grid alignItems="center" className={classes.marginBottom3unit} container spacing={2}>
        <Grid className={isSmDown ? `` : classes.noIcon} item md={3} sm={4} xs={12}>
          <TextField
            className={classes.textField}
            fullWidth
            id="date"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{ inputProps: { max: payload.dateTo } }}
            label={`From ${!helpersValidation.supportsTypeDate() ? `(yyyy-mm-dd)` : ``}`}
            onChange={(e) => {
              if (isValidRange(e.target.value)) {
                return false;
              }
              setPayload({
                ...payload,
                dateFrom: e.target.value,
              });
              setIsCustom(true);
            }}
            type="date"
            value={payload.dateFrom}
          />
        </Grid>
        <Grid item md={3} sm={4} xs={12}>
          <TextField
            className={classes.textField}
            fullWidth
            id="date"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: {
                max: moment()
                  .subtract(1, `days`)
                  .format(`YYYY-MM-DD`),
              },
            }}
            label={`To ${!helpersValidation.supportsTypeDate() ? `(yyyy-mm-dd)` : ``}`}
            onChange={(e) => {
              if (isValidRange(e.target.value)) {
                setPayload({
                  ...payload,
                  dateTo: moment()
                    .subtract(1, `days`)
                    .format(`YYYY-MM-DD`),
                });
                return false;
              }
              setPayload({
                ...payload,
                dateTo: e.target.value,
              });
              setIsCustom(true);
            }}
            type="date"
            value={payload.dateTo}
          />
        </Grid>
      </Grid>
      <Grid alignItems="center" container spacing={2}>
        <Grid className={classNames(!isSmDown && classes.noIcon, classes.marginTop1unit, classes.marginBottom3unit)} item md={6} sm={8} xs={12}>
          {isDownloading ? (
            <Spinner />
          ) : (
            <Button color="primary" fullWidth onClick={requestDownload} variant="outlined">
              Access report
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid className={classNames(!isSmDown && classes.noIcon)} item>
          <WarningIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="caption">Your download will begin immediately.</Typography>
          <Typography variant="caption">File size and download time will vary based on date range.</Typography>
        </Grid>
      </Grid>
      <Grid alignItems="center" container spacing={2}>
        <Grid className={classNames(!isSmDown && classes.noIcon)} item>
          <WarningIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="caption">
            Report data shown for information purposes only. Please refer to your Boral Tax Invoice for final fees and charges
          </Typography>
        </Grid>
      </Grid>
      <Grid alignItems="center" container spacing={2}>
        <Grid className={classNames(!isSmDown && classes.noIcon)} item>
          <WarningIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="caption">Information subject to change where applicable</Typography>
        </Grid>
      </Grid>
      <Grid alignItems="center" container spacing={2}>
        <Grid className={classNames(!isSmDown && classes.noIcon)} item>
          <LinkIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
        </Grid>
        <Grid item xs={8}>
          <a className={classes.hyperlink} href={REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL} rel="noopener noreferrer" target="_blank">
            <Typography variant="caption">Abridged Conditions of Quotation and Supply - Concrete</Typography>
          </a>
        </Grid>
      </Grid>
    </React.Fragment>
  ) : null;
};

export default compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(reportFormStyles), { withTheme: true }),
  connect(
    (state) => ({}),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(ReportForm);
